import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,  // Initial state should have a user object
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;  // Store the user object in state
    },
    logout: (state) => {
      state.user = null;  // Clear the user object on logout
    },
  },
});

export const { login, logout } = userSlice.actions;

export const selectUser = (state) => state.user.user;  // Correctly select the user object

export default userSlice.reducer;
